import classNames from 'classnames';
import React from 'react';

const Table = ({
  data,
  headers,
  containerClassName = '',
  headersClassNames = '',
  rowsClassName = '',
  hiddenColumns = [],
  stickyHeaders = false,
}) => {
  if (!data || data.length === 0) {
    return null;
  }

  const dataHeaders = Object.keys(data[0]);
  const displayHeaders = headers || dataHeaders;

  return (
    <div
      className={classNames(
        'overflow-x-auto',
        { 'max-h-[65vh]': stickyHeaders },
        containerClassName,
      )}
    >
      <table className="min-w-full">
        <thead
          className={classNames(
            'bg-gray-100',
            { 'sticky top-0 z-10': stickyHeaders },
            headersClassNames,
          )}
        >
          <tr>
            {displayHeaders.map(
              (header, index) =>
                !hiddenColumns.includes(index) && (
                  <th
                    key={header}
                    className={classNames(
                      'xl:px-4 py-2 text-left font-semibold text-gray-700',
                      headersClassNames,
                    )}
                  >
                    {header}
                  </th>
                ),
            )}
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr
              key={index}
              className={`${index % 2 === 0 ? 'bg-gray-50' : 'bg-white'}`}
            >
              {dataHeaders.map(
                (header, index) =>
                  !hiddenColumns.includes(index) && (
                    <td
                      key={header}
                      className={classNames(
                        row[header]?.columnClassName ||
                          'xl:px-4 py-2 text-gray-700 text-left',
                        rowsClassName,
                      )}
                    >
                      <div>{row[header]?.element || row[header]}</div>
                    </td>
                  ),
              )}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default Table;
